class LocationHelper {
  static parseLocationId(state) {
    try {
      const locationId = state.split("/")[1];
      return locationId;
    } catch (error) {
      return null;
    }
  }

  static parseMetaInfo(state) {
    try {
      return JSON.parse(state);
    } catch (error) {
      return null;
    }
  }
}

export default LocationHelper;
